import React from 'react'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useStore } from '../../../../hooks/useStore'
import { MapBackground } from './subcomponents/map-background'
import { MapCloudsTransition } from './subcomponents/map-clouds-transition'
import { MapInteractiveOverlay } from './subcomponents/map-interactive-overlay'
import MapNavUI from './subcomponents/map-nav-ui/MapNavUI'

const Map = React.memo(({data}) => {
    const {uiStore: {updateMapOffset}} = useStore();
    const {ref, inView} = useInView({triggerOnce: true, threshold: .5});

    return (
        <div className={inView ? "in-view" : ""} ref={ref} onMouseMove={updateMapOffset}>
            <MapNavUI/>
            <MapBackground ready={inView}/>
            <MapCloudsTransition/>
            <MapInteractiveOverlay ready={inView} data={data}/>
            <style jsx>{`
                div {
                    position: relative;
                    height: 0;
                    padding-bottom: 56.247521%;
                    background: var(--color--taupe);
                    transition: background .2s ease 2.2s;
                }

                .in-view {
                    background: white;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    div {
                        display: none;
                    }
                }
            `}</style>
        </div>
    )
});


export default Map